import { FC, Fragment } from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface DeloitteProgressProps extends CircularProgressProps {
    value: number;
}

export const DeloitteProgress: FC<DeloitteProgressProps> = (props) => {
    return (
        <Box position="relative" display="inline-flex"
            height={props.size ?? 46}
            width={props.size ?? 46}
            style={{
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            {props.value !== 100 &&
                <Fragment>
                    <CircularProgress variant={props.variant} {...props} />
                    <Box
                        top={0}
                        left={0}
                        bottom={0}
                        right={0}
                        position="absolute"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
                            props.value,
                        )}%`}</Typography>
                    </Box>
                </Fragment>
            }
            {props.value === 100 &&
                <CheckCircleIcon color="primary" />
            }
        </Box>
    );
}
